<template>
    <div>
        <v-list dense tile style="max-height: 500px; overflow-y: scroll">
            <v-list-item-group v-model="item" color="primary">
                <v-list-item v-for="(ingredient, index) in ingredients" :key="(ingredient.id)">
                    <template v-if="editOffset !== index">
                        <v-list-item-content class="pa-0" @click="startEditing(index)">
                            {{ingredient.name}}
                        </v-list-item-content>

                        <v-list-item-icon>
                            <v-icon medium @click="deleteIngredient(ingredient.id)">mdi-delete</v-icon>
                        </v-list-item-icon>
                    </template>

                    <template v-if="editOffset===index">
                        <v-list-item-content class="pa-0" @keydown.esc="cancelEditing" @keydown.enter="updateIngredient(ingredient.id)">
                            <v-select
                                :items="ingredientCategories"
                                name="category"
                                label="التصنيفات"
                                v-model="categoryId"
                                item-text="name"
                                item-value="id"
                            ></v-select>
                            <v-text-field dense v-model="tempValue" required> {{ tempValue }}
                            </v-text-field>
                        </v-list-item-content>

                        <v-list-item-icon>
                            <v-icon medium @click="updateIngredient(ingredient.id, ingredient.category.id)">mdi-content-save</v-icon>
                            <v-icon medium @click="cancelEditing">mdi-close-circle</v-icon>
                        </v-list-item-icon>
                    </template>
                </v-list-item>

                <v-list-item v-for="(input, index) in inputs" :key="index">
                    
                    <v-list-item-content class="pa-0">
                        <v-select
                        :items="ingredientCategories"
                        name="category"
                        label="التصنيفات"
                        v-model="categoryId"
                        item-text="name"
                        item-value="id"
                    ></v-select>

                        <v-text-field dense v-model="input.one" required> {{ input.one }}
                        </v-text-field>
                    </v-list-item-content>
                    <v-list-item-icon justify="space-around">
                        <span class="group">                  
                            <v-icon medium @click="createIngredient(index, categoryId)" :disabled="input.one === ''">mdi-plus-circle</v-icon> 
                            <v-icon medium @click="deleteRow(index)">mdi-close-circle</v-icon>  
                        </span>                    
                    </v-list-item-icon>
                </v-list-item>
            </v-list-item-group>
        </v-list>

        <div class="text-center pt-2">
            <v-btn color="secondary" class="black--text" :disabled="disableAdd" small @click="addRow">إضافة عنصر</v-btn>
        </div>

    </div>
</template>

<script>
    import {
        GET_INGREDIENTS,
        ADD_INGREDIENT,
        UPDATE_INGREDIENT,
        DELETE_INGREDIENT 
    } from '../graphql/Ingredients'
    import {
        GET_INGREDIENT_CATEGORIES,
    } from '../graphql/IngredientCategories'

    export default {
        data() {
            return {
                item: -1,
                ingredientCategories: '',
                ingredients: '',
                disableAdd: false,
                editOffset: -1,
                tempValue: null,
                inputs: [],
                categoryId: null
            }
        },
        apollo: {
            ingredients: {
                query: GET_INGREDIENTS
            },
            ingredientCategories: {
                query: GET_INGREDIENT_CATEGORIES
            }
        },
        methods: {
            addRow() {
                this.disableAdd = true
                this.inputs.push({
                    one: ''
                })
            },
            deleteRow(index) {
                this.disableAdd = false
                this.inputs.splice(index, 1)
            },
            startEditing: function (index) {
                this.disableAdd = true
                this.editOffset = index;
                this.tempValue = this.ingredients[index].name
                this.categoryId = this.ingredients[index].category.id
            },
            cancelEditing: function () {
                this.disableAdd = false
                this.editOffset = -1;
                this.tempValue = null;
            },
            createIngredient(index, categoryId) {
                this.$apollo.mutate({
                    mutation: ADD_INGREDIENT,
                    variables: {
                        name: this.inputs[index].one,
                        categoryId
                    },
                    update: (cache, {data: {createIngredient} }) => {
                        //First read the query you want to update

                        const data = cache.readQuery({
                            query: GET_INGREDIENTS
                        })

                        // Create updated data
                        data.ingredients.push(createIngredient)
                        // Write updated data back to the query
                        cache.writeQuery({
                            query: GET_INGREDIENTS,
                            data
                        })
                    },
                    // Ensures data is added immediately

                    optimisticResponse: {
                        __typename: 'Mutation',
                        createIngredient: {
                            __typename: 'Ingredient',
                            name: this.inputs[index].one
                        }
                    }

                }).then(({ data}) => {
                    this.disableAdd = false
                    this.inputs.splice(index, 1)
                    this.ingredients = this.$apollo.queries.ingredients.refetch()
                    return data
                })
                .catch(err => {
                    console.log(err)
                })
            },
            updateIngredient(id, categoryId) {
                this.$apollo.mutate({
                    mutation: UPDATE_INGREDIENT,
                    variables: {
                        id: id,
                        name: this.tempValue,
                        categoryId: this.categoryId
                    },
                    update: (cache, {data: { updateIngredient }}) => {
                        //First read the query you want to update

                        const data = cache.readQuery({
                            query: GET_INGREDIENTS
                        })

                        let index = data.ingredients.findIndex(category => category.id === updateIngredient.id) 

                        let updatedIngredients = [
                            ...data.ingredients.slice(0, index),
                            updateIngredient,
                            ...data.ingredients.slice(index + 1)
                        ]
                        // Write updated data back to the query
                        cache.writeQuery({
                            query: GET_INGREDIENTS,
                            data: updatedIngredients
                        })
                    },
                    // Ensures data is added immediately

                    optimisticResponse: {
                        __typename: 'Mutation',
                        updateIngredient: {
                            __typename: 'Ingredient',
                            name: this.tempValue
                        }
                    }

                }).then(({data}) => {
                    this.disableAdd = false
                    this.editOffset = -1
                    return data
                })
                .catch(err => {
                    console.log(err)
                })
            },
            deleteIngredient(id) {
                this.$apollo.mutate({
                    mutation: DELETE_INGREDIENT,
                    variables: {
                        id: id
                    },
                    update: (cache, {data: { deleteIngredient }}) => {
                        //First read the query you want to update
                        const data = cache.readQuery({
                            query: GET_INGREDIENTS
                        })

                        let index = data.ingredients.findIndex(category => category.id === deleteIngredient.id) 

                        data.ingredients.splice(index, 1)
                        // Write updated data back to the query
                        cache.writeQuery({
                            query: GET_INGREDIENTS,
                            data
                        })
                    },

                }).then(({data}) => {
                    this.editOffset = -1
                    return data
                })
                .catch(err => {
                    console.log(err)
                })
            }
        }
    }
</script>

<style scoped>

</style>